import type { Theme } from "@/contexts/theme/context";

const THEME_STORAGE_KEY = "app-theme-v2";

/**
 * Web version - uses localStorage instead of Tauri store
 */
export const saveThemeToTauriStore = async (theme: Theme) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (error) {
    console.error("Failed to save theme:", error);
  }
};

export const loadThemeFromTauriStore = async (): Promise<Theme | null> => {
  try {
    const theme = localStorage.getItem(THEME_STORAGE_KEY);
    if (theme === "light" || theme === "dark" || theme === "system") {
      return theme as Theme;
    }
    return null;
  } catch (error) {
    console.error("Failed to load theme:", error);
    throw error;
  }
};
